import moment from "moment";

let popoverShown = false;

const Util = {
  get apiSegment() {
    const value = ColorCalcModule ? ColorCalcModule.apiSegment() : '';
    return value;
  },
  get defaultDate() {
    return moment(moment(new Date()).format("YYYY-MM-DD")).format("YYYY-MM-DDTHH:mm");
  },
  formatDate(date) {
    try {
      if (!date) return '';
      return moment(date).format("YYYY/MM/DD HH:mm");
    } catch (error) {
      console.error(error);
    }
  },
  hideProgress() {
    const element = document.getElementById("loading-indicator");
    if (!element) return;
    element.style.display = "none";
  },
  navigateToRoot(event) {
    const node = document.getElementById("config");
    if (!node) return;
    node.click();
  },
  popover(event) {
    event.stopImmediatePropagation();
    event.preventDefault();
    if (popoverShown) return;
    function bodyOnClick(event) {
      event.stopImmediatePropagation();
      // Hide popover
      [...document.getElementsByClassName('popover')].forEach(element => {
        element.style.display = "none";
      });
      popoverShown = false;
      document.body.removeEventListener("click", bodyOnClick);
    }
    popoverShown = true;
    // Show popovers available
    [...document.getElementsByClassName('popover')].forEach(element => {
      element.style.display = "block";
    });
    // Listen click on body to hide popovers
    document.body.addEventListener("click", bodyOnClick);
  },
  popoverInit() {
    [...document.getElementsByClassName("HelpToggle")].forEach(element => {
      // Remove previous listeners just in case
      element.removeEventListener("click", Util.popover);
      // Add listener
      element.addEventListener("click", Util.popover);
    });
  },
  queryString(params = {}) {
    const keys = Object.keys(params);
    return keys.reduce((acc, key, index) => {
      if (index) acc += "&";
      acc += `${key}=${params[key]}`;
      return acc;
    }, "?");
  },
  showProgress() {
    const element = document.getElementById("loading-indicator");
    if (!element) return;
    element.style.display = "block";
  },
};
export default Util;
